module.exports = __webpack_public_path__ + "static/media/navigation-logo.431d5314.svg";